import {
  AttributeDataType,
  CustomField,
  CustomFieldsValue
} from "@wingspanhq/wingspan-api-sdk";
import { convertDataTypeBooleanToBoolean } from "../../../shared/utils/convertDataTypeBoolean";

/**
 * v3 types each custom-field value by its definition's `dataType` and answers
 * 422 `InvalidFormat` on a mismatch, so a Boolean field must carry a real
 * boolean — v1's stringified `"true"` / `"false"` is rejected.
 */
export const selectorPayeeCustomFieldsRequest = (params: {
  fields: CustomField[];
  values: Record<string, unknown>;
}): { [key: string]: CustomFieldsValue } => {
  const request: { [key: string]: CustomFieldsValue } = {};

  params.fields.forEach(field => {
    if (!field.key) {
      return;
    }

    const value = params.values[field.key];

    request[field.key] =
      field.dataType === AttributeDataType.BOOLEAN
        ? convertDataTypeBooleanToBoolean(value)
        : (value ?? "");
  });

  return request;
};
